<template>
  <tr class="man-wrap cp" :class="{ rows__single: type === 'rows' }" @click="showCardModal=true">
    <div class="cards__single" v-if="type === 'cards'">
          <span class="link-not-like photo bcard__photo">
            <img v-if="card.front_photo" :src="$media_url + card.front_photo" alt="photo"/>
          </span>
      <div class="cards__main-info">
        <h2>
          <span class="link-not-like">{{ card.fullname }}</span>
        </h2>
        <span class="main-info__description">
              {{ card.company_name }}
            </span>
      </div>
      <div class="cards__buttons">
        <button class="btn-icon btn-action"
                @click.stop="$emit('edit', card.id)">
          <edit-icon/>
        </button>
        <button class="btn-icon btn-action"
                @click.stop="confirm_archive_modal=true">
          <archive-icon/>
        </button>
        <button v-if="!card.active" class="btn-icon btn-action"
                @click.stop="confirm_open(card.id)">
          <delete-icon/>
        </button>
      </div>
      <ul class="cards__info">
        <li>
          <span>
            <svg width="20" height="19" viewBox="0 0 20 19" fill="none"
                 xmlns="http://www.w3.org/2000/svg"><path
              d="M11.2004 10.0004C11.8369 10.0004 12.4474 10.2532 12.8974 10.7033C13.3475 11.1534 13.6004 11.7639 13.6004 12.4004V14.2004C13.6004 16.6652 11.0948 18.4004 7.00039 18.4004C2.90599 18.4004 0.400391 16.6652 0.400391 14.2004V12.4004C0.400391 11.7639 0.653247 11.1534 1.10333 10.7033C1.55342 10.2532 2.16387 10.0004 2.80039 10.0004H11.2004ZM11.2004 11.2004H2.80039C2.48213 11.2004 2.17691 11.3268 1.95186 11.5519C1.72682 11.7769 1.60039 12.0821 1.60039 12.4004V14.2004C1.60039 15.8888 3.49519 17.2004 7.00039 17.2004C10.5056 17.2004 12.4004 15.8888 12.4004 14.2004V12.4004C12.4004 12.0821 12.274 11.7769 12.0489 11.5519C11.8239 11.3268 11.5186 11.2004 11.2004 11.2004ZM17.2004 10.0004C17.8369 10.0004 18.4474 10.2532 18.8974 10.7033C19.3475 11.1534 19.6004 11.7639 19.6004 12.4004V13.0004C19.6004 15.5072 17.7188 17.2004 14.2004 17.2004C14.0312 17.2004 13.8644 17.1968 13.7036 17.1884C13.9532 16.898 14.162 16.586 14.33 16.2512L14.4464 15.9956H14.4932C17.1716 15.9176 18.4004 14.7524 18.4004 13.0004V12.4004C18.4004 12.0821 18.274 11.7769 18.0489 11.5519C17.8239 11.3268 17.5186 11.2004 17.2004 11.2004H14.5952C14.4381 10.7577 14.196 10.3501 13.8824 10.0004H17.2004ZM7.00039 0.400391C7.55194 0.400391 8.09809 0.509027 8.60766 0.720097C9.11723 0.931166 9.58023 1.24054 9.97024 1.63054C10.3602 2.02055 10.6696 2.48355 10.8807 2.99312C11.0918 3.50269 11.2004 4.04884 11.2004 4.60039C11.2004 5.15194 11.0918 5.69809 10.8807 6.20766C10.6696 6.71723 10.3602 7.18023 9.97024 7.57024C9.58023 7.96025 9.11723 8.26962 8.60766 8.48069C8.09809 8.69176 7.55194 8.80039 7.00039 8.80039C5.88648 8.80039 4.81819 8.35789 4.03054 7.57024C3.24289 6.78259 2.80039 5.7143 2.80039 4.60039C2.80039 3.48648 3.24289 2.4182 4.03054 1.63054C4.81819 0.842889 5.88648 0.400391 7.00039 0.400391ZM15.4004 2.80039C16.196 2.80039 16.9591 3.11646 17.5217 3.67907C18.0843 4.24168 18.4004 5.00474 18.4004 5.80039C18.4004 6.59604 18.0843 7.3591 17.5217 7.92171C16.9591 8.48432 16.196 8.80039 15.4004 8.80039C14.6047 8.80039 13.8417 8.48432 13.2791 7.92171C12.7165 7.3591 12.4004 6.59604 12.4004 5.80039C12.4004 5.00474 12.7165 4.24168 13.2791 3.67907C13.8417 3.11646 14.6047 2.80039 15.4004 2.80039ZM7.00039 1.60039C6.20474 1.60039 5.44168 1.91646 4.87907 2.47907C4.31646 3.04168 4.00039 3.80474 4.00039 4.60039C4.00039 5.39604 4.31646 6.1591 4.87907 6.72171C5.44168 7.28432 6.20474 7.60039 7.00039 7.60039C7.79604 7.60039 8.5591 7.28432 9.12171 6.72171C9.68432 6.1591 10.0004 5.39604 10.0004 4.60039C10.0004 3.80474 9.68432 3.04168 9.12171 2.47907C8.5591 1.91646 7.79604 1.60039 7.00039 1.60039ZM15.4004 4.00039C14.923 4.00039 14.4652 4.19003 14.1276 4.5276C13.79 4.86516 13.6004 5.323 13.6004 5.80039C13.6004 6.27778 13.79 6.73562 14.1276 7.07318C14.4652 7.41075 14.923 7.60039 15.4004 7.60039C15.8778 7.60039 16.3356 7.41075 16.6732 7.07318C17.0107 6.73562 17.2004 6.27778 17.2004 5.80039C17.2004 5.323 17.0107 4.86516 16.6732 4.5276C16.3356 4.19003 15.8778 4.00039 15.4004 4.00039Z"
              fill="#2C1521"/></svg>
          </span>
          <span>{{ card.position }}</span>
        </li>
        <li>
          <span>
             <svg width="12" height="20" viewBox="0 0 12 20" fill="none"
                  xmlns="http://www.w3.org/2000/svg"><path
               d="M4.8 14.8004C4.64087 14.8004 4.48826 14.8636 4.37574 14.9761C4.26321 15.0886 4.2 15.2413 4.2 15.4004C4.2 15.5595 4.26321 15.7121 4.37574 15.8247C4.48826 15.9372 4.64087 16.0004 4.8 16.0004H7.2C7.35913 16.0004 7.51174 15.9372 7.62426 15.8247C7.73679 15.7121 7.8 15.5595 7.8 15.4004C7.8 15.2413 7.73679 15.0886 7.62426 14.9761C7.51174 14.8636 7.35913 14.8004 7.2 14.8004H4.8Z"
               fill="#2C1521"/><path
               d="M2.4 0.400391C1.76348 0.400391 1.15303 0.653247 0.702944 1.10333C0.252856 1.55342 0 2.16387 0 2.80039V17.2004C0 17.8369 0.252856 18.4474 0.702944 18.8974C1.15303 19.3475 1.76348 19.6004 2.4 19.6004H9.6C10.2365 19.6004 10.847 19.3475 11.2971 18.8974C11.7471 18.4474 12 17.8369 12 17.2004V2.80039C12 2.16387 11.7471 1.55342 11.2971 1.10333C10.847 0.653247 10.2365 0.400391 9.6 0.400391H2.4ZM1.2 2.80039C1.2 2.48213 1.32643 2.17691 1.55147 1.95186C1.77652 1.72682 2.08174 1.60039 2.4 1.60039H9.6C9.91826 1.60039 10.2235 1.72682 10.4485 1.95186C10.6736 2.17691 10.8 2.48213 10.8 2.80039V17.2004C10.8 17.5187 10.6736 17.8239 10.4485 18.0489C10.2235 18.274 9.91826 18.4004 9.6 18.4004H2.4C2.08174 18.4004 1.77652 18.274 1.55147 18.0489C1.32643 17.8239 1.2 17.5187 1.2 17.2004V2.80039Z"
               fill="#2C1521"/></svg>
          </span>
          <a :href="'tel:' + card.phone.replace(/\s/g, '')">{{ card.phone }} </a>
        </li>
        <li>
          <span>
             <svg width="20" height="17" viewBox="0 0 20 17" fill="none"
                  xmlns="http://www.w3.org/2000/svg"><path
               d="M16.6004 0.799805C17.396 0.799805 18.1591 1.11588 18.7217 1.67848C19.2843 2.24109 19.6004 3.00416 19.6004 3.7998V13.3998C19.6004 14.1955 19.2843 14.9585 18.7217 15.5211C18.1591 16.0837 17.396 16.3998 16.6004 16.3998H3.40039C2.60474 16.3998 1.84168 16.0837 1.27907 15.5211C0.716461 14.9585 0.400391 14.1955 0.400391 13.3998V3.7998C0.400391 3.00416 0.716461 2.24109 1.27907 1.67848C1.84168 1.11588 2.60474 0.799805 3.40039 0.799805H16.6004ZM18.4004 5.553L10.3052 10.317C10.2287 10.3619 10.1431 10.3893 10.0547 10.3972C9.96631 10.4051 9.87727 10.3933 9.79399 10.3626L9.69559 10.317L1.60039 5.5554V13.3998C1.60039 13.8772 1.79003 14.335 2.1276 14.6726C2.46516 15.0102 2.923 15.1998 3.40039 15.1998H16.6004C17.0778 15.1998 17.5356 15.0102 17.8732 14.6726C18.2107 14.335 18.4004 13.8772 18.4004 13.3998V5.553ZM16.6004 1.9998H3.40039C2.923 1.9998 2.46516 2.18945 2.1276 2.52701C1.79003 2.86458 1.60039 3.32242 1.60039 3.7998V4.1622L10.0004 9.10381L18.4004 4.15981V3.7998C18.4004 3.32242 18.2107 2.86458 17.8732 2.52701C17.5356 2.18945 17.0778 1.9998 16.6004 1.9998Z"
               fill="#2C1521"/></svg>
          </span>
          <a :href="'mailto:' + card.email">{{ card.email }}</a>
        </li>
        <li v-if="card.site">
          <span>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                 xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd"
                                                          d="M0 9C0 11.3869 0.948212 13.6761 2.63604 15.364C4.32387 17.0518 6.61305 18 9 18C11.3869 18 13.6761 17.0518 15.364 15.364C17.0518 13.6761 18 11.3869 18 9C18 6.61305 17.0518 4.32387 15.364 2.63604C13.6761 0.948212 11.3869 0 9 0C6.61305 0 4.32387 0.948212 2.63604 2.63604C0.948212 4.32387 0 6.61305 0 9ZM16.8 9C16.8 10.9778 15.7985 13.0015 14.4 14.4C13.0015 15.7985 10.9778 16.8 9 16.8C7.02224 16.8 4.99849 15.7985 3.6 14.4C2.20151 13.0015 1.2 10.9778 1.2 9C1.2 7.02224 2.20151 4.99849 3.6 3.6C4.99849 2.20151 7.02224 1.2 9 1.2C10.9778 1.2 13.0015 2.20151 14.4 3.6C15.7985 4.99849 16.8 7.02224 16.8 9Z"
                                                          fill="#2C1521"/><path
              fill-rule="evenodd" clip-rule="evenodd"
              d="M5.14286 9.00001C5.14286 13.6512 6.67646 17.4857 9 17.4857C11.3235 17.4857 12.8571 13.6512 12.8571 9.00001C12.8571 4.34881 11.3235 0.514291 9 0.514291C6.67646 0.514291 5.14286 4.34881 5.14286 9.00001ZM11.6603 9.00001C11.6603 12.8695 10.0851 16.29 9 16.29C7.91486 16.29 6.34028 12.8695 6.34028 9.00001C6.34028 5.13052 7.91486 1.71001 9 1.71001C10.0851 1.71001 11.6603 5.13052 11.6603 9.00001Z"
              fill="#2C1521"/><path
              d="M2.41908 4.3375L3.45383 3.19373C3.55668 3.2863 3.6688 3.37887 3.78811 3.46835C5.09543 4.44755 7.1824 5.39 9.46068 5.39C11.4057 5.39 13.217 4.61315 14.5326 3.86127C14.8494 3.68024 15.1312 3.48378 15.375 3.27498L16.3768 4.44858C16.0579 4.72115 15.6969 4.97315 15.2989 5.19944C13.7395 6.09224 11.6639 6.59418 9.46068 6.59418C6.86663 6.59418 4.45669 5.89681 2.8624 4.70264C2.7091 4.5878 2.56117 4.46596 2.41908 4.3375Z"
              fill="#2C1521"/><path
              d="M2.41908 13.679L3.45383 14.8227C3.55668 14.7291 3.6688 14.6376 3.78811 14.5481C5.09543 13.5689 7.1824 12.61 9.46068 12.61C11.4057 12.61 13.217 13.4033 14.5326 14.1552C14.8494 14.3362 15.1312 14.5327 15.375 14.7415L16.3768 13.5679C16.0417 13.2845 15.6808 13.0331 15.2989 12.817C13.7395 11.9242 11.6639 11.4223 9.46068 11.4223C6.86663 11.4223 4.45669 12.1196 2.8624 13.3138C2.7091 13.4287 2.56117 13.5505 2.41908 13.679Z"
              fill="#2C1521"/><path d="M1 9.6V8.4H17V9.6H1Z" fill="#2C1521"/></svg>

          </span>
          <a :href="card.site.indexOf('http') === 0 ? card.site : ('//'+card.site)" target="_blank"
             @click.stop="">{{ card.site }}</a>
        </li>
      </ul>
    </div>
    <template v-if="type === 'rows'">
      <template v-for="(header) in headers">
        <template v-if="$parent.showHeaders[header.key]">
          <td v-if="header.key === 'fullname'" :key="header.key">
            <a v-if="card.site" class="flex" :href="card.site.indexOf('http') === 0 ? card.site : ('//'+card.site)"
               target="_blank">
              <div class="avatar">
                <img v-if="card.front_photo" :src="$media_url + card.front_photo" alt=""/>
              </div>
              {{ card[header.key] }}
            </a>
            <span v-else class="flex">
              <div class="avatar">
                            <img v-if="card.front_photo" :src="$media_url + card.front_photo" alt=""/>
                          </div>
                          {{ card[header.key] }}
            </span>
          </td>
          <td v-else-if="header.key==='phone'" :key="header.key">
            <a :href="'tel:' + card[header.key].replace(/\s/g, '')">{{ card[header.key] }} </a>
          </td>
          <td v-else-if="header.key==='email'" :key="header.key">
            <a :href="'mailto:' + card[header.key]">{{ card[header.key] }}</a>
          </td>
          <td v-else :key="header.key">{{ card[header.key] }}</td>
        </template>
      </template>
      <td class="rows__dot-menu">
        <v-menu bottom right>
          <template v-slot:activator="{ on, attrs }">
            <v-btn dark icon v-bind="attrs" v-on="on">
              <svg
                v-bind="attrs"
                v-on="on"
                width="20"
                height="5"
                viewBox="0 0 20 5"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="2" cy="2.5" r="2" fill="#2C1521"/>
                <circle cx="10" cy="2.5" r="2" fill="#2C1521"/>
                <circle cx="18" cy="2.5" r="2" fill="#2C1521"/>
              </svg>
            </v-btn>
          </template>
          <div class="rows__dot-menu-content">
            <div class="btn-wrap" @click.stop="$emit('edit', card.id)">
              {{ $vuetify.lang.t('$vuetify.edit') }}
              <button class="btn-icon btn-action">
                <edit-icon/>
              </button>
            </div>
            <div class="btn-wrap"
                 @click.stop="confirm_archive_modal=true">
              <span v-if="card.active">{{ $vuetify.lang.t('$vuetify.toArchive') }}</span>
              <span v-else>{{ $vuetify.lang.t('$vuetify.deleteArchive') }}</span>
              <button class="btn-icon btn-action">
                <archive-icon/>
              </button>
            </div>
            <div v-if="!card.active" class="btn-wrap"
                 @click.stop="confirm_open(card.id)">
              {{ $vuetify.lang.t("$vuetify.delete") }}
              <button class="btn-icon btn-action">
                <delete-icon/>
              </button>
            </div>
          </div>
        </v-menu>
      </td>
    </template>
    <ConfirmModal v-model="confirm_modal" @confirm="tmp_delete">
      <span v-if="alertError">{{ alertMsg }}</span>
    </ConfirmModal>
    <ConfirmArchiveModal v-model="confirm_archive_modal" @confirm="tmp_archive" :active="card.active">
      <span v-if="alertError">{{ alertMsg }}</span>
    </ConfirmArchiveModal>

    <v-dialog v-model="showCardModal">
      <div class="modal modal-big business-card">
        <div class="flex business-card__images">
          <img class="cp" v-if="card.front_photo" :src="$media_url + card.front_photo" alt="" @click="index=0"/>
          <img class="cp" v-if="card.back_photo" :src="$media_url + card.back_photo" alt="" @click="index=1"/>
        </div>
        <div class=" business-card__row">
          <span class="bolder">{{ $vuetify.lang.t('$vuetify.surnameName') }}</span>
          <span>{{ card.fullname }}</span>
        </div>
        <div class="business-card__row">
          <span class="bolder">{{ $vuetify.lang.t('$vuetify.company') }}</span>
          <span>{{ card.company_name }}</span>
        </div>
        <div class="business-card__row">
          <span class="bolder">{{ $vuetify.lang.t('$vuetify.speciality') }}</span>
          <span>{{ card.position }}</span>
        </div>
        <div class="business-card__row">
          <span class="bolder">{{ $vuetify.lang.t('$vuetify.phone') }}</span>
          <span><a :href="'tel:' + card.phone.replace(/\s/g, '')">{{ card.phone }} </a></span>
        </div>
        <div class="business-card__row" v-if="card.work_phone">
          <span class="bolder">{{ $vuetify.lang.t('$vuetify.otherPhone') }}</span>
          <span><a :href="'tel:' + card.work_phone.replace(/\s/g, '')">{{ card.work_phone }} </a></span>
        </div>
        <div class="business-card__row">
          <span class="bolder">{{ $vuetify.lang.t('$vuetify.email') }}</span>
          <span><a :href="'mailto:' + card.email">{{ card.email }}</a></span>
        </div>
        <div class="business-card__row" v-if="card.site">
          <span class="bolder">{{ $vuetify.lang.t('$vuetify.website') }}</span>
          <span><a :href="card.site.indexOf('http') === 0 ? card.site : ('//'+card.site)" target="_blank">{{
              card.site
            }}</a></span>
        </div>
        <div class="business-card__row">
          <span class="bolder">{{ $vuetify.lang.t('$vuetify.address') }}</span>
          <span><a target="_blank"
                   :href="'https://www.google.com/maps/search/?api=1&query='+card.address.replaceAll(' ', '+')">
                    {{ card.address }}
                  </a></span>
        </div>
        <div class="business-card__row" v-if="card.comment">
          <span class="bolder">{{ $vuetify.lang.t('$vuetify.accounting.card.comment') }}</span>
          <pre>{{card.comment}}</pre>
        </div>
      </div>
    </v-dialog>

    <CoolLightBox
      :items="card.back_photo ? [$media_url + card.front_photo, $media_url + card.back_photo] : [$media_url + card.front_photo]"
      :index="index"
      @close="index = null;">
    </CoolLightBox>
  </tr>
</template>

<script>
import ConfirmModal from "@/components/confirmModal.vue";
import EditIcon from "@/components/icons/EditIcon";
import ArchiveIcon from "@/components/icons/ArchiveIcon";
import DeleteIcon from "@/components/icons/DeleteIcon";
import ConfirmArchiveModal from "@/components/ConfirmArchiveModal";

export default {
  name: "BusinessCardCard",

  components: {
    ConfirmArchiveModal,
    DeleteIcon,
    ArchiveIcon,
    EditIcon,
    ConfirmModal,
  },

  props: {
    type: String,
    card: Object,
    headers: Array,
  },

  data: function () {
    return {
      tmp: false,

      confirm_modal: false,
      confirm_archive_modal: false,
      tmp_to_delete: "",

      alertMsg: "",
      alertError: false,

      showCardModal: false,
      index: '',
    };
  },

  methods: {
    confirm_open(id) {
      this.confirm_modal = true;
      this.tmp_to_delete = id;
    },

    confirm_close() {
      this.confirm_modal = false;
      this.tmp_to_delete = "";
    },

    tmp_delete() {
      this.$axios
        .delete(this.$hostname + "time-tracking/businesscards/" + this.card.id, {
          headers: {
            Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                sessionStorage.getItem("auth_token")),
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => {
          this.confirm_modal = false;
          this.$destroy();
          this.$el.parentNode.removeChild(this.$el);
        })
        .catch((response) => {
          this.alertMsg = this.$catch(response);
          this.alertError = true;
        });
    },

    tmp_archive() {
      this.$axios({
        url: this.$hostname + "time-tracking/businesscards/" + this.card.id,
        method: "PUT",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {
          active: !this.card.active
        },
      }).then(() => {
        this.confirm_archive_modal = false
        this.$emit('archive')
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },
  },
}
</script>

<style scoped>

</style>